var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99975 6.49995V9.83328M9.99975 13.1666H10.0081M8.84585 2.24305L1.99178 14.0819C1.61161 14.7386 1.42153 15.0669 1.44962 15.3364C1.47412 15.5714 1.59727 15.785 1.7884 15.924C2.00753 16.0833 2.38691 16.0833 3.14568 16.0833H16.8538C17.6126 16.0833 17.992 16.0833 18.2111 15.924C18.4022 15.785 18.5254 15.5714 18.5499 15.3364C18.578 15.0669 18.3879 14.7386 18.0077 14.0819L11.1537 2.24305C10.7748 1.58875 10.5854 1.26159 10.3383 1.15172C10.1228 1.05587 9.87672 1.05587 9.66117 1.15172C9.41406 1.26159 9.22466 1.58875 8.84585 2.24305Z",
    stroke: "#C54528",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.8389ecd80fc1e0bb1487ade4c118657d.svg";
export { ForwardRef as ReactComponent };